import { URLS } from './urls'

export type AppEnvironment = 'dev' | 'prod'

const isAppEnvironment = (value: string): value is AppEnvironment =>
	value === 'dev' || value === 'prod'

const currentAppEnv = URLS.APP_ENV

if (!isAppEnvironment(currentAppEnv)) {
	throw new Error(`Invalid app environment: ${currentAppEnv}`)
}

export const APP_ENV = {
	CURRENT: currentAppEnv,
	IS_DEV: currentAppEnv === 'dev',
	IS_PROD: currentAppEnv === 'prod',
} as const
